// Theme toggle: clay (default) ↔ cyberpunk. Persisted in localStorage.

const KEY = 'heromind.theme';

export function getTheme() {
  return localStorage.getItem(KEY) || 'clay';
}

export function setTheme(theme) {
  localStorage.setItem(KEY, theme);
  document.documentElement.dataset.theme = theme === 'cyberpunk' ? 'cyberpunk' : '';
}

export function toggleTheme() {
  const next = getTheme() === 'cyberpunk' ? 'clay' : 'cyberpunk';
  setTheme(next);
  return next;
}

// Apply on import
setTheme(getTheme());

if (typeof window !== 'undefined') {
  window.toggleTheme = toggleTheme;
  window.getTheme = getTheme;
}
